if (document.getElementById("blog")) {
  const blogSwitcher = document.querySelectorAll('[name="blogSwitch"]');
  const blogLoader = document.getElementById("blog--loader");
  const forumLoader = document.getElementById("forum--loader");
  const blogContent = document.getElementById("blog--content");
  blogSwitcher.forEach(el => {
    el.addEventListener("change", () => {
      const target = el.value;
      console.log(target);
      switch (target) {
        case "blog":
          blogLoader.style.display = "";
          forumLoader.style.display = "none";
          blogContent.style.backgroundColor = "white";
          break;
        case "forum":
          blogLoader.style.display = "none";
          forumLoader.style.display = "block";
          blogContent.style.backgroundColor = "#F6F6F6";
          break;
        default:
          blogLoader.style.display = "";
          forumLoader.style.diplay = "none";
      }
    });
  });
}
